var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 87,
    viewBox: "0 0 90 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_44050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0075 83.9411L72.8108 86.4356L69.1075 83.7164L45.1226 66.1254L45.0019 66.034L44.7982 66.1825L20.8925 83.7164L17.1854 86.4356L17.9887 83.9411L25.1427 61.7076L25.5047 60.5918L27.8127 53.4206L27.0773 52.8836L22.6235 49.6121L0 33.0151H34.3784L45.0019 0L55.6216 33.0151H90L67.3765 49.6121L62.9227 52.8836L62.1873 53.4206L64.4953 60.5918L64.8573 61.7076L72.0075 83.9411Z",
    fill: "url(#paint0_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9982 64.8419L19.0032 83.9182L28.9328 53.0549L2.93408 33.9786H35.0686L44.9982 3.11523L54.9278 33.9786H87.0623L61.0673 53.0549L70.9969 83.9182L44.9982 64.8419Z",
    fill: "url(#paint1_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 63.3642L21.2508 80.7877L30.3243 52.5978L6.57324 35.1744H35.9284L44.9981 6.98071L54.0717 35.1744H83.423L59.6757 52.5978L68.7455 80.7877L44.9981 63.3642Z",
    fill: "url(#paint2_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5751V6.98071L35.9282 35.1744L44.998 45.5751Z",
    fill: "url(#paint3_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5751V6.98071L54.0716 35.1744L44.998 45.5751Z",
    fill: "url(#paint4_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5752L30.3243 52.5979L21.2507 80.7877L44.9981 45.5752Z",
    fill: "url(#paint5_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5752L59.6756 52.5979L68.7454 80.7877L44.998 45.5752Z",
    fill: "url(#paint6_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5753L35.9284 35.1746H6.57324L44.9981 45.5753Z",
    fill: "url(#paint7_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5753L54.0716 35.1746H83.4229L44.998 45.5753Z",
    fill: "url(#paint8_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5753L6.57324 35.1746L30.3243 52.598L44.9981 45.5753Z",
    fill: "url(#paint9_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5753L83.4229 35.1746L59.6756 52.598L44.998 45.5753Z",
    fill: "url(#paint10_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5752V63.3643L21.2507 80.7877L44.9981 45.5752Z",
    fill: "url(#paint11_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.998 45.5752V63.3643L68.7454 80.7877L44.998 45.5752Z",
    fill: "url(#paint12_linear_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5751C45.6375 45.5751 46.1559 37.2015 46.1559 26.872C46.1559 16.5426 45.6375 8.16895 44.9981 8.16895C44.3587 8.16895 43.8403 16.5426 43.8403 26.872C43.8403 37.2015 44.3587 45.5751 44.9981 45.5751Z",
    fill: "url(#paint13_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9981 45.5751C45.6375 45.5751 46.1559 37.2015 46.1559 26.872C46.1559 16.5426 45.6375 8.16895 44.9981 8.16895C44.3587 8.16895 43.8403 16.5426 43.8403 26.872C43.8403 37.2015 44.3587 45.5751 44.9981 45.5751Z",
    fill: "url(#paint14_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7254 38.9372C43.5274 42.1782 45.4054 45.1488 44.9227 45.5753C44.44 46.0018 41.7775 43.7168 38.9793 40.4758C36.1773 37.2349 34.2992 34.2643 34.7819 33.8378C35.2647 33.4151 37.9234 35.6963 40.7254 38.9372Z",
    fill: "url(#paint15_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7254 38.9372C43.5274 42.1782 45.4054 45.1488 44.9227 45.5753C44.44 46.0018 41.7775 43.7168 38.9793 40.4758C36.1773 37.2349 34.2992 34.2643 34.7819 33.8378C35.2647 33.4151 37.9234 35.6963 40.7254 38.9372Z",
    fill: "url(#paint16_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2904 48.3974C40.7857 46.2533 44.6512 44.9889 44.9228 45.5716C45.1943 46.1543 41.7738 48.367 37.2785 50.5111C32.7832 52.6552 28.9177 53.9196 28.6462 53.3369C28.3747 52.7543 31.7989 50.5416 36.2904 48.3974Z",
    fill: "url(#paint17_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2904 48.3974C40.7857 46.2533 44.6512 44.9889 44.9228 45.5716C45.1943 46.1543 41.7738 48.367 37.2785 50.5111C32.7832 52.6552 28.9177 53.9196 28.6462 53.3369C28.3747 52.7543 31.7989 50.5416 36.2904 48.3974Z",
    fill: "url(#paint18_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2747 38.9372C46.4727 42.1782 44.5946 45.1488 45.0773 45.5753C45.5601 46.0018 48.2225 43.7168 51.0208 40.4758C53.8228 37.2349 55.7009 34.2643 55.2181 33.8378C54.7354 33.4151 52.0729 35.6963 49.2747 38.9372Z",
    fill: "url(#paint19_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2747 38.9372C46.4727 42.1782 44.5946 45.1488 45.0773 45.5753C45.5601 46.0018 48.2225 43.7168 51.0208 40.4758C53.8228 37.2349 55.7009 34.2643 55.2181 33.8378C54.7354 33.4151 52.0729 35.6963 49.2747 38.9372Z",
    fill: "url(#paint20_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7058 48.3974C49.2105 46.2533 45.345 44.9889 45.0735 45.5716C44.8019 46.1543 48.2224 48.367 52.7177 50.5111C57.213 52.6552 61.0785 53.9196 61.35 53.3369C61.6215 52.7543 58.2011 50.5416 53.7058 48.3974Z",
    fill: "url(#paint21_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7058 48.3974C49.2105 46.2533 45.345 44.9889 45.0735 45.5716C44.8019 46.1543 48.2224 48.367 52.7177 50.5111C57.213 52.6552 61.0785 53.9196 61.35 53.3369C61.6215 52.7543 58.2011 50.5416 53.7058 48.3974Z",
    fill: "url(#paint22_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8189 38.6897C35.6379 41.866 45.0848 44.9508 44.9226 45.5754C44.7567 46.1999 35.042 44.1282 23.2231 40.9519C11.4041 37.7757 1.95341 34.6909 2.11934 34.0663C2.2815 33.4418 11.9999 35.5097 23.8189 38.6897Z",
    fill: "url(#paint23_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8189 38.6897C35.6379 41.866 45.0848 44.9508 44.9226 45.5754C44.7567 46.1999 35.042 44.1282 23.2231 40.9519C11.4041 37.7757 1.95341 34.6909 2.11934 34.0663C2.2815 33.4418 11.9999 35.5097 23.8189 38.6897Z",
    fill: "url(#paint24_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6442 63.5129C38.4437 53.2454 44.3909 45.2173 44.9226 45.5752C45.4544 45.9332 40.3708 54.5479 33.5713 64.8153C26.7718 75.0828 20.8246 83.1109 20.2929 82.7529C19.7611 82.3911 24.8409 73.7765 31.6442 63.5129Z",
    fill: "url(#paint25_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6442 63.5129C38.4437 53.2454 44.3909 45.2173 44.9226 45.5752C45.4544 45.9332 40.3708 54.5479 33.5713 64.8153C26.7718 75.0828 20.8246 83.1109 20.2929 82.7529C19.7611 82.3911 24.8409 73.7765 31.6442 63.5129Z",
    fill: "url(#paint26_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0604 38.6897C54.2414 41.866 44.7945 44.9508 44.9566 45.5754C45.1226 46.1999 54.8372 44.1282 66.6562 40.9519C78.4752 37.7757 87.9221 34.6909 87.7599 34.0663C87.5978 33.4418 77.8831 35.5097 66.0604 38.6897Z",
    fill: "url(#paint27_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0604 38.6897C54.2414 41.866 44.7945 44.9508 44.9566 45.5754C45.1226 46.1999 54.8372 44.1282 66.6562 40.9519C78.4752 37.7757 87.9221 34.6909 87.7599 34.0663C87.5978 33.4418 77.8831 35.5097 66.0604 38.6897Z",
    fill: "url(#paint28_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2351 63.5129C51.4356 53.2454 45.4884 45.2173 44.9566 45.5752C44.4249 45.9332 49.5085 54.5479 56.308 64.8153C63.1075 75.0828 69.0547 83.1109 69.5864 82.7529C70.1182 82.3911 65.0384 73.7765 58.2351 63.5129Z",
    fill: "url(#paint29_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2351 63.5129C51.4356 53.2454 45.4884 45.2173 44.9566 45.5752C44.4249 45.9332 49.5085 54.5479 56.308 64.8153C63.1075 75.0828 69.0547 83.1109 69.5864 82.7529C70.1182 82.3911 65.0384 73.7765 58.2351 63.5129Z",
    fill: "url(#paint30_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9415 66.2778C45.5809 66.2778 46.0992 60.9886 46.0992 54.4641C46.0992 47.9396 45.5809 42.6504 44.9415 42.6504C44.302 42.6504 43.7837 47.9396 43.7837 54.4641C43.7837 60.9886 44.302 66.2778 44.9415 66.2778Z",
    fill: "url(#paint31_radial_288_44050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9415 66.2778C45.5809 66.2778 46.0992 60.9886 46.0992 54.4641C46.0992 47.9396 45.5809 42.6504 44.9415 42.6504C44.302 42.6504 43.7837 47.9396 43.7837 54.4641C43.7837 60.9886 44.302 66.2778 44.9415 66.2778Z",
    fill: "url(#paint32_radial_288_44050)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_44050",
    x1: -1.21572,
    y1: 4.37685,
    x2: 84.9051,
    y2: 89.6566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_288_44050",
    x1: 9.42788,
    y1: 14.9126,
    x2: 71.7608,
    y2: 76.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_288_44050",
    x1: 7.56673,
    y1: 12.7689,
    x2: 84.8612,
    y2: 89.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_288_44050",
    x1: 40.4639,
    y1: 46.1755,
    x2: 40.4639,
    y2: 5.84504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_288_44050",
    x1: 54.99,
    y1: 15.8548,
    x2: 33.4946,
    y2: 37.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_288_44050",
    x1: 22.5315,
    y1: 79.1043,
    x2: 40.8534,
    y2: 43.4579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_288_44050",
    x1: 67.4672,
    y1: 79.1044,
    x2: 49.1453,
    y2: 43.4579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_288_44050",
    x1: 7.12131,
    y1: 36.2309,
    x2: 52.6691,
    y2: 41.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859,
    stopColor: "#7E5A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3018,
    stopColor: "#B5913D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#DDB951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#F6D25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7247,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_288_44050",
    x1: 87.233,
    y1: 33.6687,
    x2: 46.6015,
    y2: 40.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4627,
    stopColor: "#F6D25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5871,
    stopColor: "#DDB951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#B5913D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    stopColor: "#7E5A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_288_44050",
    x1: 41.2962,
    y1: 50.3277,
    x2: 1.40378,
    y2: 36.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_288_44050",
    x1: 43.2508,
    y1: 52.1903,
    x2: 83.1432,
    y2: 38.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_288_44050",
    x1: 46.3744,
    y1: 52.4901,
    x2: 23.1054,
    y2: 85.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4207,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6131,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8525,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_288_44050",
    x1: 38.5998,
    y1: 45.2564,
    x2: 61.8688,
    y2: 78.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#FFD845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3869,
    stopColor: "#FFDB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#CBA748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#835F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664216"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9994 26.8712) scale(1.15845 18.7052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9994 26.8712) scale(1.15845 18.7052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8527 39.7063) rotate(-41.3726) scale(1.16346 7.75579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8527 39.7063) rotate(-41.3726) scale(1.16346 7.75579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7866 49.4562) rotate(-115.037) scale(1.16807 9.01515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7866 49.4562) rotate(-115.037) scale(1.16807 9.01515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1462 39.7063) rotate(-138.627) scale(1.16346 7.75579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1462 39.7063) rotate(-138.627) scale(1.16346 7.75579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2122 49.4562) rotate(-64.9631) scale(1.16807 9.01515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2122 49.4562) rotate(-64.9631) scale(1.16807 9.01515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5197 39.8197) rotate(-75.2392) scale(1.16954 22.1564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5197 39.8197) rotate(-75.2392) scale(1.16954 22.1564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6064 64.1625) rotate(-145.972) scale(1.16228 22.2944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6064 64.1625) rotate(-145.972) scale(1.16228 22.2944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3599 39.8197) rotate(-104.761) scale(1.16954 22.1564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3599 39.8197) rotate(-104.761) scale(1.16954 22.1564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2733 64.1625) rotate(-34.0279) scale(1.16229 22.2946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2733 64.1625) rotate(-34.0279) scale(1.16229 22.2946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9397 54.4639) scale(1.15848 11.8161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_288_44050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9397 54.4639) scale(1.15848 11.8161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#F3C237",
    stopOpacity: 0.9115
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2499,
    stopColor: "#D2A830",
    stopOpacity: 0.7501
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#9D7D24",
    stopOpacity: 0.5338
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7295,
    stopColor: "#534213",
    stopOpacity: 0.2705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_44050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 86.4356,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.af63bc73e56c4a0863408ce6e58345b8.svg";
export { ForwardRef as ReactComponent };